export default __webpack_public_path__ + "static/media/custom_solutions_background.c2ee6122.png";